var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"LLModalLayout",class:_vm.classes},[_c('div',{staticClass:"LLModalLayout__content"},[_vm._t("content")],2),(_vm.wActions)?_c('div',{staticClass:"LLModalLayout__actions"},[_vm._t("actions")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }